import { Component } from 'react'
import { Outlet, Route, Routes } from 'react-router'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../utils'
import GoalsStore from '../../models/Goals'
import { AddGoal } from './forms'
import { GoalsDashboard } from './dashboard'
import { Page } from './elements'

class Goals extends Component {
  constructor(props) {
    super(props)
    const { store } = props
    this.state = GoalsStore.create({}, { store })
  }

  render() {
    const { location } = this.props

    return (
      <Routes location={location}>
        {/* Keep the dashboard outside Page.Container because it defines its own width
      and gutters. */}
        <Route
          element={
            <Page.Container>
              <Outlet />
            </Page.Container>
          }>
          <Route path='/add' element={<AddGoal />} />
        </Route>
        {/* The dashboard resolves the matching drawer from the route itself. */}
        <Route path='/replace-income' element={<GoalsDashboard />} />
        <Route path='/:id/*' element={<GoalsDashboard />} />
        <Route path='/' element={<GoalsDashboard />} />
      </Routes>
    )
  }
}

export default withRouterProps(inject('store')(observer(Goals)))
